import { Product } from '@bowtie-web/common';
import { Box } from '@material-ui/core';
import { useCallback } from 'react';
import { QuotationContextValue } from '../contexts/QuotationContext';
import ProductCard from './ProductCard/ProductCard';

type Props = Pick<
  QuotationContextValue,
  'activeProduct' | 'coupon' | 'products' | 'bulkQuotation' | 'socialProof'
> & {
  onActiveProductChange: QuotationContextValue['setActiveProduct'];
  formValues: QuotationContextValue['values'];
  size: 'small' | 'large';
  isValid: boolean;
};

const ResultPanel = ({
  activeProduct,
  onActiveProductChange,
  products,
  isValid,
  size,
  bulkQuotation,
  socialProof,
}: Props) => {
  const handleClick = useCallback(
    (newActiveProduct: Product) => {
      onActiveProductChange(newActiveProduct);
    },
    [onActiveProductChange],
  );

  return (
    <Box
      display="flex"
      flexDirection={size === 'small' ? 'column' : 'row'}
      gridGap={16}
    >
      {products.map((product, ix) => {
        const quotation = bulkQuotation.find(
          quotation => quotation.product.code === product.code,
        )?.quotation;

        return (
          <ProductCard
            key={ix}
            product={product}
            selected={product.code === activeProduct?.code}
            onClick={handleClick}
            isValid={isValid}
            size={size}
            quotation={quotation}
            socialProof={socialProof}
          />
        );
      })}
    </Box>
  );
};

export default ResultPanel;
